import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import DateOrMonthPicker from 'Components/ComponentLibrary/Molecules/DateOrMonthPicker';
import DateOrMonthForGroupedInputPicker from 'Components/ComponentLibrary/Molecules/DateOrMonthForGroupedInputPicker';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride('endDate', {
    _component: () => DateOrMonthPicker,
    _customProps: {
      testName: 'date-or-month-picker',
    },
  })
  .nameOverride('dateOfPurchase', {
    _component: () => DateOrMonthForGroupedInputPicker,
    _customProps: {
      testName: 'date-or-month-picker',
    },
  })
  .nameOverride('sellDate', {
    _component: () => DateOrMonthForGroupedInputPicker,
    _customProps: {
      testName: 'date-or-month-picker',
    },
  });
